import script from "./ProductSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSelect.vue?vue&type=script&setup=true&lang=js"

import "./ProductSelect.vue?vue&type=style&index=0&id=524b9b6f&lang=css"

const __exports__ = script;

export default __exports__